import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=3cb08d1a&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=3cb08d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb08d1a",
  null
  
)

export default component.exports